import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useCreateMarkTemplate = () => {
    const additional = useQueryRequestParams();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('mark-templates/create/'), body, additional)
    });
};
export default useCreateMarkTemplate;
